import { render } from "./WriteOffRuleNative.vue?vue&type=template&id=1dafe29d&scoped=true"
const script = {}

import "./WriteOffRuleNative.vue?vue&type=style&index=0&id=1dafe29d&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/h5-subscription-client-prod-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dafe29d"]])

export default __exports__